(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ProdutoModalCtrl', ProdutoModalController);

  ProdutoModalController.$inject = [
    '$scope',
    'products',
    'preSelected',
    'allowMultiple',
    'fetchProducts',
    'MessagesService'
  ];

  const MIN_SEARCH_LENGTH = 3;

  // eslint-disable-next-line max-lines-per-function, max-params
  function ProdutoModalController($scope, products, preSelected, allowMultiple, fetchProducts, MessagesService) {
    const vm = this;

    vm.selected = (preSelected || []).filter(Boolean);
    vm.products = sortProducts(products);
    vm.allowMultiple = allowMultiple;
    vm.filter = '';
    vm.loadingProducts = false;
    vm.hasServerFilter = !!fetchProducts;
    vm.minSearchLength = MIN_SEARCH_LENGTH;

    vm.close = close;
    vm.canSeeStock = canSeeStock;
    vm.toggle = toggle;
    vm.save = save;
    vm.search = search;
    vm.onFilterKeydown = onFilterKeydown;

    let searchRequestId = 0;

    function sortProducts(list) {
      return (list || []).slice().sort(function(a, b) {
        const aSelected = vm.selected.includes(a) ? 0 : 1;
        const bSelected = vm.selected.includes(b) ? 0 : 1;
        if (aSelected !== bSelected) {
          return aSelected - bSelected;
        }
        return (a.descricao || '').localeCompare(b.descricao || '', 'pt-BR');
      });
    }

    function toggle(prod) {
      if (vm.allowMultiple) {
        if (vm.selected.includes(prod)) {
          return vm.selected.splice(vm.selected.indexOf(prod), 1);
        }
        vm.selected.push(prod);
      } else {
        vm.selected[0] = prod;
      }
    }

    function search() {
      if (!fetchProducts || vm.filter.length < MIN_SEARCH_LENGTH) {
        return;
      }

      vm.loadingProducts = true;
      const currentRequestId = ++searchRequestId;

      fetchProducts(vm.filter)
        .then(function(data) {
          if (currentRequestId !== searchRequestId) {
            return;
          }
          const results = (data || []).map(function(item) {
            return vm.selected.find(function(sel) {
              return (sel.item_id || sel.item_codigo || sel.id || sel.cd_item) === item.id;
            }) || item;
          });
          vm.products = sortProducts(results);
        })
        .catch(function() {
          if (currentRequestId === searchRequestId) {
            MessagesService.alert('Erro ao buscar produtos. Tente novamente.');
          }
        })
        .finally(function() {
          if (currentRequestId === searchRequestId) {
            vm.loadingProducts = false;
          }
        });
    }

    function onFilterKeydown($event) {
      if ($event.keyCode === 13) {
        search();
      }
    }

    function close() {
      $scope.$dismiss();
    }

    function canSeeStock(product) {
      let result = $scope.$root.permissions.estoque.canViewStock && $scope.$root.parametros.tem_controle_de_estoque;
      if (product) {
        result = result && check(product);
      } else {
        result = result && vm.products.some(check);
      }
      return result;

      function check(prod) {
        return !_.isUndefined(prod.saldo_fisico) || !_.isUndefined(prod.saldo_receber);
      }
    }

    function save() {
      if (vm.allowMultiple) {
        return $scope.$close(vm.selected);
      }
      $scope.$close(vm.selected[0]);
    }
  }
}());
